import React from 'react';
import { Folder } from 'lucide-react';

interface FolderBadgeProps {
  folderName: string;
  className?: string;
}

export const FolderBadge: React.FC<FolderBadgeProps> = ({ folderName, className = '' }) => {
  return (
    <div
      className={`inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-md ${className}`}
      style={{
        backgroundColor: '#f3f4f6',
        color: '#374151',
        border: '1px solid #e5e7eb',
      }}
    >
      <Folder size={12} />
      <span>{folderName}</span>
    </div>
  );
};
